// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XO5D","colBig":"styles_colBig__3NgxO","colSmall":"styles_colSmall__2ugSM"};